<ion-item
    [attr.button]="(button || routerLink) && !disabled"
    (click)="onItemClick()"
    [lines]="lines"
    [ngClass]="{ 'border-top': borderTop }"
    [disabled]="disabled">
    <lib-svg-icon *ngIf="iconName" [iconName]="iconName" slot="start" [color]="iconColor || ''" />
    <ng-content></ng-content>
    <lib-svg-icon *ngIf="detail" iconName="chevron-right" slot="end" [color]="iconColor || ''" />
</ion-item>
